export default function () {
  return {
    products: null,
  };
}
